import { render, staticRenderFns } from "./AddEditBreakdown.vue?vue&type=template&id=206360be&"
import script from "./AddEditBreakdown.vue?vue&type=script&lang=js&"
export * from "./AddEditBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports